import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { AppLayout } from "./components/Layout/AppLayout";
import { Toaster } from "sonner";

// Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import Assignments from "./pages/Assignments";
import AssignmentDetail from "./pages/AssignmentDetail";
import AccountingWorkspace from "./pages/AccountingWorkspace";
import Gradebook from "./pages/Gradebook";
import Analytics from "./pages/Analytics";
import AdminConsole from "./pages/AdminConsole";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    {/* Public routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />

                    {/* Protected routes */}
                    <Route element={<AppLayout />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/courses" element={<Courses />} />
                        <Route path="/courses/:courseId" element={<CourseDetail />} />
                        <Route path="/assignments" element={<Assignments />} />
                        <Route path="/assignments/:assignmentId" element={<AssignmentDetail />} />
                        <Route path="/workspace" element={<AccountingWorkspace />} />
                        <Route path="/admin" element={<AdminConsole />} />
                        <Route path="/gradebook" element={<Gradebook />} />
                        <Route path="/analytics" element={<Analytics />} />
                    </Route>

                    {/* Redirect root to dashboard or login */}
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </AuthProvider>
    );
}

export default App;
